<div class="row">
  <div class="col-12">
    <h1>Menu</h1>
    <h4>
      <a
        href="https://material.angular.io/components/progress-bar/examples"
        title="Material chips"
        target="_blank"
        >Doc</a
      >
    </h4>

    <button
      aria-label="Example icon-button with a menu"
      mat-icon-button
      [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>dialpad</mat-icon>
        <span>Redial</span>
      </button>
      <button
        disabled
        mat-menu-item>
        <mat-icon>voicemail</mat-icon>
        <span>Check voice mail</span>
      </button>
      <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Disable alerts</span>
      </button>
    </mat-menu>
  </div>
</div>
